import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRequest =
        error.config?.url?.includes('/login') ||
        error.config?.url?.includes('/register');
      if (!isAuthRequest) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const journeyService = {
  getJourneys: async () => {
    const response = await api.get('/journeys');
    return response.data;
  },
  getJourney: async (id) => {
    const response = await api.get(`/journeys/${id}`);
    return response.data;
  },
  createJourney: async (data) => {
    const response = await api.post('/journeys', data);
    return response.data;
  },
  updateJourney: async (id, data) => {
    const response = await api.put(`/journeys/${id}`, data);
    return response.data;
  },
  deleteJourney: async (id) => {
    const response = await api.delete(`/journeys/${id}`);
    return response.data;
  },
  getReasons: async () => {
    const response = await api.get('/journey-reasons');
    return response.data;
  },
};
